import { VisitaEstado } from '../consts/visitasStatus';

interface MotivoFalla {
    codigo: string;
    descripcion: string;
}

interface VisitaDisplayConfig {
    color: 'azul' | 'ambar';
    icono: boolean;
    tooltip: string | null;
}

// SMP-179: ademas de la visita "En Revision" con motivo de falla (HU-2.1.02), una visita
// Pendiente con motivoFalla es una fallida que volvio a Pendiente para replanificarse, y debe
// mostrar el mismo badge ambar (ver Escenario 2 y 4: el estado de visita "Fallida" se mantiene
// sea cual sea la solapa donde se muestra).
const getVisitaDisplayConfig = (estado: number, motivoFalla: MotivoFalla | null): VisitaDisplayConfig => {
    const esFallida =
        (estado === VisitaEstado.REALIZADA || estado === VisitaEstado.PENDIENTE) &&
        motivoFalla != null;

    if (!esFallida) {
        return { color: 'azul', icono: false, tooltip: null };
    }

    return {
        color: 'ambar',
        icono: true,
        tooltip: motivoFalla?.descripcion ? `Fallida: ${motivoFalla.descripcion}` : 'Fallida'
    };
};

export { getVisitaDisplayConfig };
export type { MotivoFalla, VisitaDisplayConfig };
